export const votes = [
  {
    source: "sam",
    target: "seraph",
    postId: 85,
  },
  {
    source: "margi",
    target: "seraph",
    postId: 122,
  },
  {
    source: "sam",
    target: "seraph",
    postId: 171,
  },
  {
    source: "cinera",
    target: "seraph",
    postId: 124,
  },
  {
    source: "pompom",
    target: "seraph",
    postId: 161,
  },
  {
    source: "pompom",
    target: "shad",
    postId: 130,
  },
  {
    source: "cinera",
    target: "shad",
    postId: 150,
  },
  {
    source: "gb",
    target: "shad",
    postId: 163,
  },
  {
    source: "kira",
    target: "pompom",
    postId: 3,
  },
  {
    source: "asako",
    target: "pompom",
    postId: 137,
  },
  {
    source: "shad",
    target: "pompom",
    postId: 164,
  },
  {
    source: "brandish",
    target: "mary",
    postId: 146,
  },
  {
    source: "kira",
    target: "mary",
    postId: 168,
  },
  {
    source: "mary",
    target: "gb",
    postId: 113,
  },
  {
    source: "uber",
    target: "gb",
    postId: 128,
  },
  {
    source: "scav",
    target: "tatsu",
    postId: 134,
  },
  {
    source: "james",
    target: "tatsu",
    postId: 140,
  },
  {
    source: "misha",
    target: "sam",
    postId: 19,
  },
  {
    source: "seraph",
    target: "cinera",
    postId: 119,
  },
  {
    source: "tatsu",
    target: "scav",
    postId: 129,
  },
  {
    source: "shad",
    target: "brandish",
    postId: 94,
  },
];
